import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to remove the parent actor from a string.
 */
@Pipe({
    name: 'removeParentActor',
    standalone: false
})
export class RemoveParentActorPipe implements PipeTransform {

  transform(removeFrom: string, parentActorName: string | undefined): string {
    if (parentActorName) {
      const indexOfOrgSuffix = removeFrom.lastIndexOf(`_${parentActorName}`);
      return indexOfOrgSuffix > 0 ? removeFrom.substring(0, indexOfOrgSuffix) : removeFrom;
    }
    return removeFrom;
  }

}
